export default {
    value: {
        type: "boolean",
        default: false,
        bind: {
            to: "attr",
            name: "data-value"
        }
    }
}   